const ModalAndTooltip = {
  showModal(url, data, additionalOptions) {
    if(typeof additionalOptions === 'undefined')
      additionalOptions = {};

    jQueryShowQtip(url, data, jQuery.extend(additionalOptions, { customWidth: additionalOptions.modalWidth }));
  },

  openModal(selector, modalOptions){
    modalOptions = getDefaultVal(modalOptions, {});
    selector = getDefaultVal(selector, "#remoteModal");
    jQuery(selector).modal(modalOptions, 'show');
  },

  closeModal(selector){
    selector = getDefaultVal(selector, "#remoteModal");
    jQuery(selector).modal('hide');
  },

  destroyTooltip(selector) {
    jQuery(selector).tooltip("dispose");
  },

  addTooltip(selector, text){
    jQuery(selector).tooltip({title: text, container: 'body'});
  },

  showManagementReportModal(url) {
    ModalAndTooltip.showModal(url, {}, { modal: true, largeModal: true, successCallback: function(){ document.body.classList.add('modal-open') }});
  }
}

export default ModalAndTooltip;
